import { createContext, ReactNode, useContext, useEffect, useState } from "react"

interface PrivacyContextType {
  isBlurred: boolean
  toggleBlur: () => void
}

const PrivacyContext = createContext<PrivacyContextType | undefined>(undefined)

interface PrivacyProviderProps {
  children: ReactNode
}

export function PrivacyProvider({ children }: PrivacyProviderProps) {
  const [isBlurred, setIsBlurred] = useState(() => {
    // Load from localStorage on mount
    const saved = localStorage.getItem("privacy_blur_enabled")
    return saved === "true"
  })

  useEffect(() => {
    // Save to localStorage whenever it changes
    localStorage.setItem("privacy_blur_enabled", String(isBlurred))
  }, [isBlurred])

  const toggleBlur = () => {
    setIsBlurred((prev) => !prev)
  }

  const value: PrivacyContextType = {
    isBlurred,
    toggleBlur,
  }

  return <PrivacyContext.Provider value={value}>{children}</PrivacyContext.Provider>
}

export function usePrivacy(): PrivacyContextType {
  const context = useContext(PrivacyContext)
  if (context === undefined) {
    throw new Error("usePrivacy must be used within a PrivacyProvider")
  }
  return context
}
